import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined'
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined'
import {
  Box,
  Divider,
  Grid,
  Stack,
  SvgIconProps,
  Typography,
} from '@mui/material'
import { ComponentType } from 'react'

interface ValueColumn {
  Icon: ComponentType<SvgIconProps>
  iconColor: string
  title: string
  body: string
}

// SIPP-843: the "3 Cs" — Convenience / Cost / Community — sit above Step 1
// so users land on a value-prop framing before the plan choice.
const COLUMNS: readonly ValueColumn[] = [
  {
    Icon: AutorenewOutlinedIcon,
    iconColor: 'primary.main',
    title: 'Set it and forget it',
    body:
      'SIPP Pro turns filter maintenance into a one-time setup. From there, you get the right replacements automatically when needed, quarterly test kits to keep tabs on your water, and alerts when conditions in your area change.',
  },
  {
    Icon: SavingsOutlinedIcon,
    iconColor: 'success.main',
    title: '$0.27 a day for clean water',
    body:
      "That's less than $99 a year for filter fulfillment, quarterly testing, and continuous monitoring. You won't find a better deal — even with Amazon Subscribe & Save.",
  },
  {
    Icon: GroupsOutlinedIcon,
    iconColor: 'primary.main',
    title: "You're part of something bigger",
    body:
      'Every test you run helps build a more accurate, community-powered water monitoring mesh. The more people test, the better we get at spotting problems specific to you — or endemic to everyone nearby.',
  },
]

export const SippProValueCard = () => (
  <Box
    sx={{
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 2,
      p: { xs: 2.5, md: 3 },
      bgcolor: 'background.paper',
      width: '100%',
    }}
  >
    <Typography variant="h5" fontWeight={700} sx={{ mb: 2.5 }}>
      Why SIPP Pro is worth it
    </Typography>
    <Grid container spacing={3} alignItems="stretch">
      {COLUMNS.map((column, idx) => (
        <Grid
          key={column.title}
          size={{ xs: 12, md: 4 }}
          sx={{ display: 'flex', alignItems: 'stretch' }}
        >
          <Stack
            direction="row"
            spacing={2}
            sx={{ flex: 1 }}
            alignItems="flex-start"
          >
            {idx > 0 && (
              <Divider
                orientation="vertical"
                flexItem
                sx={{ display: { xs: 'none', md: 'block' }, mr: 2 }}
              />
            )}
            <Box>
              <column.Icon
                sx={{ color: column.iconColor, fontSize: 28, mb: 1 }}
              />
              <Typography variant="body1" fontWeight={700} sx={{ mb: 0.5 }}>
                {column.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {column.body}
              </Typography>
            </Box>
          </Stack>
        </Grid>
      ))}
    </Grid>
  </Box>
)
